// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"📚4-7-06h5Nj","Image":"📚4-7-01QgNu"};